var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Verwaltungsbereich")]),_c('div',{staticClass:"content_container"},[_c('Navigation',{attrs:{"items":_vm.components,"active":_vm.active},on:{"click":_vm.updateNavigation}}),_c('div',{staticClass:"content"},[_c('SettingsTable',{attrs:{"item":_vm.activeItem}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }